import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  createFlowSelection,
  editFlowSelection,
  getFlowSelectionsDatatable,
  getFlowSelectionById,
  changePublishState,
} from './thunks';
import { FlowSelectionsState } from './types';

export const name = 'FlowSelecions';

const initialState: FlowSelectionsState = {
  flowSelectionsDatatable: { status: 'idle', data: null },
  flowSelectionById: {
    status: 'idle',
    data: null,
  },
  createFlowSelection: {
    status: 'idle',
    data: null,
  },
  editFlowSelection: {
    status: 'idle',
    data: null,
  },
  changePublishState: {
    status: 'idle',
    data: null,
  },
};

export const getFlowSelectionsDatatableAsync = createAsyncThunk(
  name + '/getFlowSelectionsDatatable',
  getFlowSelectionsDatatable
);

export const getFlowSelectionByIdAsync = createAsyncThunk(
  name + '/getFlowSelectionById',
  getFlowSelectionById
);

export const createFlowSelectionAsync = createAsyncThunk(
  name + '/createFlowSelection',
  createFlowSelection
);

export const editFlowSelectionAsync = createAsyncThunk(
  name + '/editFlowSelection',
  editFlowSelection
);

export const changePublishStateAsync = createAsyncThunk(
  name + '/changePublishState',
  changePublishState
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearFlowSelection: (state) => {
      state.flowSelectionById.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFlowSelectionsDatatableAsync.pending, (state) => {
        state.flowSelectionsDatatable.status = 'loading';
      })
      .addCase(getFlowSelectionsDatatableAsync.fulfilled, (state, action) => {
        state.flowSelectionsDatatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getFlowSelectionsDatatableAsync.rejected, (state) => {
        state.flowSelectionsDatatable.status = 'failed';
      })
      .addCase(getFlowSelectionByIdAsync.pending, (state) => {
        state.flowSelectionById.status = 'loading';
      })
      .addCase(getFlowSelectionByIdAsync.fulfilled, (state, action) => {
        state.flowSelectionById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getFlowSelectionByIdAsync.rejected, (state) => {
        state.flowSelectionById.status = 'failed';
      })
      .addCase(createFlowSelectionAsync.pending, (state) => {
        state.createFlowSelection.status = 'loading';
      })
      .addCase(createFlowSelectionAsync.fulfilled, (state, action) => {
        state.createFlowSelection = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createFlowSelectionAsync.rejected, (state) => {
        state.createFlowSelection.status = 'failed';
      })
      .addCase(editFlowSelectionAsync.pending, (state) => {
        state.editFlowSelection.status = 'loading';
      })
      .addCase(editFlowSelectionAsync.fulfilled, (state, action) => {
        state.editFlowSelection = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(editFlowSelectionAsync.rejected, (state) => {
        state.editFlowSelection.status = 'failed';
      })
      .addCase(changePublishStateAsync.pending, (state) => {
        state.changePublishState.status = 'loading';
      })
      .addCase(changePublishStateAsync.fulfilled, (state, action) => {
        state.changePublishState = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(changePublishStateAsync.rejected, (state) => {
        state.changePublishState.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
